<template>
    <footer class="bg-transparent">

        <div class="container">

            <!-- Copyright -->
            <div class="pt-2 pb-2" id="copyright">
                &copy; {{ new Date().getFullYear() }}
                جميع الحقوق محفوظة
            </div>
            <!-- Copyright -->

        </div>

    </footer>
</template>

<script>
export default {
    name: 'Footer',
}
</script>

<style lang="scss" scoped>
footer {

    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;

    #copyright {

        color: $White;
        font-size: 12px;

        @include breakpoints(x-small) {
            font-size: 10px;
        }

    }
}
</style>